import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import ScratchpadModal from './ScratchpadModal';

interface ScratchpadModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for ScratchpadModal (ADR-034).
 * Owns store access for scratchpadNotes and the update callback.
 */
const ScratchpadModalContainer: React.FC<ScratchpadModalContainerProps> = ({ isOpen, onClose }) => {
  const generalState = useStore(state => state.session?.general);
  const scratchpadNotes = generalState?.scratchpadNotes ?? '';
  const actions = useActions();

  const handleUpdateNotes = (newNotes: string) => {
    actions.updateScratchpadNotes(newNotes);
  };

  return (
    <ScratchpadModal
      isOpen={isOpen}
      onClose={onClose}
      initialNotes={scratchpadNotes}
      onUpdateNotes={handleUpdateNotes}
    />
  );
};

export default ScratchpadModalContainer;
